import React, { useRef } from 'react';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents';

export default function MapEventsLegend({
  showComplaints,
  showIncidents,
  createComplaintIcon,
  createIncidentIcon
}) {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  return (
    <div
      ref={ref}
      className="map-card map-card-compact"
      style={{
        fontSize: 12,
        minWidth: 180
      }}
    >
      {showComplaints && (
        <>
          <div className="map-card-title">
            Complaints
          </div>

          <LegendItem icon={createComplaintIcon(0)} label="Pending" />
          <LegendItem icon={createComplaintIcon(1)} label="Resolved" />
        </>
      )}

      {showIncidents && (
        <>
          <div
            className="map-card-title"
            style={{ marginTop: showComplaints ? 12 : 0 }}
          >
            Incidents
          </div>

          <LegendItem icon={createIncidentIcon(0)} label="Pending" />
          <LegendItem icon={createIncidentIcon(1)} label="Resolved" />
        </>
      )}
    </div>
  );

}

function LegendItem({ icon, label }) {
  return (
    <div className="map-card-row" style={{ marginBottom: 6 }}>
      <div
        dangerouslySetInnerHTML={{ __html: icon.options.html }}
        style={{ width: 18, height: 18 }}
      />
      <span style={{ fontSize: 12 }}>
        {label}
      </span>
    </div>
  );
}
